import { render, staticRenderFns } from "./PaymentQRPage.vue?vue&type=template&id=2aa00405&scoped=true&"
import script from "./PaymentQRPage.vue?vue&type=script&lang=js&"
export * from "./PaymentQRPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentQRPage.vue?vue&type=style&index=0&id=2aa00405&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa00405",
  null
  
)

export default component.exports